import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface FlooringProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Flooring: React.FC<FlooringProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [flooring, set_flooring] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Flooring']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Flooring': [b.values?.['Interior']?.['Flooring']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Flooring';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(flooring)}
                />
            ) : (
                <MoneyBox
                    id={'flooring'}
                    allowNegative={false}
                    value={flooring}
                    onChange={(value) => set_flooring(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
